export const base = {
    background: "cyan",
}